module.exports = __webpack_public_path__ + "img/xin-gigiwi.0339e4e8.png";